import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../lib/supabase'

export default function Pagamento() {
  const { ligaAtual, membroAtual, carregarUsuario, user } = useAuth()
  const [salvando, setSalvando] = useState(false)
  const [msg, setMsg] = useState(null)

  const jaConfirmou = membroAtual?.pagamento_confirmado
  const chavePix = ligaAtual?.chave_pix || '00020126430014BR.GOV.BCB.PIX0121paulomastro@gmail.com5204000053039865406100.005802BR5925PAULO EDUARDO R MASTROCIN6009SAO PAULO622605227XBnZRyqojfza7WEtfwRFf63043C46'
  const valorBuyin = ligaAtual?.valor_buyin

  function showMsg(texto, tipo = 'ok') {
    setMsg({ texto, tipo })
    setTimeout(() => setMsg(null), 4000)
  }

  async function alterarPagamento(novoStatus) {
    if (!membroAtual?.id) return
    setSalvando(true)
    const { error } = await supabase
      .from('membros_liga')
      .update({ pagamento_confirmado: novoStatus })
      .eq('id', membroAtual.id)
    setSalvando(false)
    if (error) {
      showMsg('Erro ao registrar. Tente novamente.', 'erro')
    } else {
      await carregarUsuario(user.id)
      showMsg(novoStatus ? 'Pagamento registrado! O comissário foi notificado. ✓' : 'Confirmação desfeita.')
    }
  }

  return (
    <div>
      <div style={s.titulo}>💳 Pagamento</div>

      {/* Status do participante */}
      <div style={{ ...s.statusCard, ...(jaConfirmou ? s.statusPago : s.statusPendente) }}>
        {jaConfirmou ? (
          <>
            <div style={s.statusIcone}>✅</div>
            <div>
              <div style={s.statusLabel}>Pagamento confirmado</div>
              <div style={s.statusSub}>Você já confirmou o pagamento da sua inscrição. Obrigado!</div>
            </div>
          </>
        ) : (
          <>
            <div style={s.statusIcone}>⏳</div>
            <div>
              <div style={s.statusLabel}>Pagamento pendente</div>
              <div style={s.statusSub}>Após realizar o PIX, clique em "Já paguei!" abaixo.</div>
            </div>
          </>
        )}
      </div>

      {/* Dados do pagamento */}
      <div style={s.card}>
        <div style={s.cardTitle}>📋 Dados para pagamento</div>

        <div style={s.row}>
          <div style={s.rowLabel}>Valor</div>
          <div style={s.rowValor}>
            {valorBuyin ? `R$ ${Number(valorBuyin).toFixed(2).replace('.', ',')}` : 'R$ 100,00'}
          </div>
        </div>

        {chavePix && (
          <div style={s.row}>
            <div style={s.rowLabel}>PIX Copia e Cola</div>
            <button style={s.btnCopiarPix} onClick={() => {
              navigator.clipboard.writeText(chavePix)
              showMsg('Código PIX copiado! Cole no app do seu banco.')
            }}>
              📋 Copiar código PIX
            </button>
          </div>
        )}

        <div style={s.row}>
          <div style={s.rowLabel}>Beneficiário</div>
          <div style={s.rowValor}>Paulo Eduardo R Mastrocinque</div>
        </div>
      </div>

      {/* QR Code */}
      <div style={s.card}>
        <div style={s.cardTitle}>📱 QR Code PIX</div>
        <div style={s.qrWrapper}>
          <img
            src="/pix-qrcode.png"
            alt="QR Code PIX"
            style={s.qrImg}
            onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block' }}
          />
          <div style={{ display: 'none', color: '#888', fontSize: 13, textAlign: 'center', padding: 20 }}>
            QR Code não disponível. Use a chave PIX acima.
          </div>
        </div>
        <div style={s.qrInstrucao}>
          Abra o app do seu banco → PIX → Pagar → Ler QR Code
        </div>
      </div>

      {/* Toast */}
      {msg && (
        <div style={{ ...s.toast, ...(msg.tipo === 'erro' ? s.toastErro : {}) }}>
          {msg.texto}
        </div>
      )}

      {/* Botão principal ou desfazer */}
      {!jaConfirmou ? (
        <button
          style={{ ...s.btnConfirmar, ...(salvando ? s.btnDisabled : {}) }}
          onClick={() => alterarPagamento(true)}
          disabled={salvando}
        >
          {salvando ? 'Registrando...' : '✅ Já paguei!'}
        </button>
      ) : (
        <button
          style={s.btnDesfazer}
          onClick={() => alterarPagamento(false)}
          disabled={salvando}
        >
          ↩️ Cliquei por engano — desfazer confirmação
        </button>
      )}

      <div style={s.aviso}>
        Ao clicar em "Já paguei!", você está confirmando que realizou a transferência.
        O comissário verifica os pagamentos e pode alterar o status manualmente.
      </div>
    </div>
  )
}

const s = {
  titulo: { fontSize: 17, fontWeight: 600, marginBottom: '1rem', color: '#0A2342' },
  statusCard: { display: 'flex', alignItems: 'flex-start', gap: 12, borderRadius: 10, padding: '12px 14px', marginBottom: '1rem', border: '0.5px solid' },
  statusPago: { background: '#EAF3DE', borderColor: '#3B6D11', color: '#3B6D11' },
  statusPendente: { background: '#FAEEDA', borderColor: '#BA7517', color: '#7A4F0E' },
  statusIcone: { fontSize: 22, flexShrink: 0 },
  statusLabel: { fontSize: 14, fontWeight: 600, marginBottom: 2 },
  statusSub: { fontSize: 12 },
  card: { background: 'white', borderRadius: 10, border: '0.5px solid #e0e0e0', padding: '14px 16px', marginBottom: '1rem' },
  cardTitle: { fontSize: 13, fontWeight: 600, color: '#0A2342', marginBottom: 12 },
  row: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 10, flexWrap: 'wrap' },
  rowLabel: { fontSize: 12, color: '#666', flexShrink: 0 },
  rowValor: { fontSize: 14, fontWeight: 500, color: '#222' },
  chavePix: { fontSize: 13, fontWeight: 500, color: '#222', background: '#f5f5f5', borderRadius: 6, padding: '4px 8px', wordBreak: 'break-all' },
  btnCopiar: { fontSize: 11, padding: '4px 10px', border: '0.5px solid #ddd', borderRadius: 6, background: 'white', cursor: 'pointer', color: '#555', flexShrink: 0 },
  btnCopiarPix: { fontSize: 13, padding: '8px 16px', border: '0.5px solid #0A2342', borderRadius: 8, background: '#0A2342', cursor: 'pointer', color: 'white', fontWeight: 500 },
  qrWrapper: { display: 'flex', justifyContent: 'center', marginBottom: 10 },
  qrImg: { width: 200, height: 200, objectFit: 'contain' },
  qrInstrucao: { fontSize: 11, color: '#888', textAlign: 'center' },
  toast: { background: '#EAF3DE', border: '0.5px solid #3B6D11', borderRadius: 8, padding: '10px 14px', marginBottom: '1rem', fontSize: 13, color: '#3B6D11' },
  toastErro: { background: '#FCEBEB', borderColor: '#A32D2D', color: '#A32D2D' },
  btnConfirmar: { width: '100%', padding: 13, background: '#0A2342', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer', marginBottom: '1rem' },
  btnDesfazer: { width: '100%', padding: 10, background: 'none', color: '#999', border: '0.5px solid #ddd', borderRadius: 8, fontSize: 12, cursor: 'pointer', marginBottom: '1rem' },
  btnDisabled: { background: '#ccc', cursor: 'not-allowed' },
  aviso: { fontSize: 11, color: '#999', textAlign: 'center', lineHeight: 1.5 },
}
